import type { PartialDeep } from 'type-fest';
import { UserFlow, SipConfig } from '../networkConfig';
import { Configuration, webSipConfig } from '../defaultConfig';

const chainConfig: PartialDeep<Configuration> = {
  flowConfigs: {
    [UserFlow.DOCUMENT]: {
      issuance: {
        providers: {
          sip: {
            authenticationDisabled: true,
          } as SipConfig,
          web: webSipConfig,
        },
      },
      // refresh: {
      //   config: {
      //     // Civic-pass-api doesn't support casper POWO yet
      //     legacyPOWOEnabled: true,
      //   },
      //   providers: {
      //     web: {
      //       authenticationDisabled: true,
      //     },
      //   },
      // },
    },
    [UserFlow.GENESIS]: {
      issuance: {
        config: {
          // Civic-pass-api doesn't support casper POWO yet
          legacyPOWOEnabled: true,
        },
        providers: {
          sip: {
            authenticationDisabled: true,
          } as SipConfig,
          web: webSipConfig,
        },
      },
      // refresh: {
      //   config: {
      //     // Civic-pass-api doesn't support casper POWO yet
      //     legacyPOWOEnabled: true,
      //   },
      //   providers: {
      //     sip: {
      //       authenticationDisabled: true,
      //     } as SipConfig,
      //   },
      // },
    },
  },
};

export default chainConfig;
